import { useState, useRef } from 'react';
import MaterialTable, { Options } from '@material-table/core';
import IconButton from '@mui/material/IconButton';
import Icon from '@mui/material/Icon';
import { useNavigate } from 'react-router';
import { loadTableData } from './loaders';
import { getApiJointList, deleteApiJointJointid } from '../services/joint';
import { JointPayload } from '../models/JointPayload';
import { urls, route } from '../route';
import { confirmAndDelete } from '../utils';
export const JointsList = () => {
    const history = useNavigate();
    const ref = useRef<any>();

    const [pagination,] = useState<Options<JointPayload>>({
        actionsColumnIndex: -1,
        selection: true,
        maxColumnSort: 0,
        pageSize: 10,

    });
    return <div>
        <MaterialTable<JointPayload>
            title="Joints"
            options={pagination}
            tableRef={ref}
            columns={[
                { title: "Id", field: "id", cellStyle: { width: "5%" } },
                { title: "Name", field: "name", width: "90%" },
                {
                    title: 'Tools',
                    render: (e) => (<>
                        <IconButton onClick={() => history(`/app/joints/edit/${e.id}`)} style={{ float: "right" }}><Icon>edit</Icon></IconButton>
                        <IconButton onClick={confirmAndDelete(e, deleteApiJointJointid, ref)} style={{ float: "right" }}><Icon>delete</Icon></IconButton>
                    </>)
                }
            ]}
            data={loadTableData(getApiJointList)}
            actions={[{
                icon: "delete",
                tooltip: "Delete",
                onClick: async (event, data) => {
                    const confirmation = window.confirm("Are you sure you want to delete the selected items?")

                    if (confirmation && Array.isArray(data)) {
                        for (const i of data) {
                            await deleteApiJointJointid(i.id);
                        }
                        if (ref.current) {
                            ref.current.onQueryChange();
                        }
                    }
                }
            }, {
                icon: "add",
                tooltip: "Add New",
                isFreeAction: true,
                onClick: () => history(route(urls.jointsAdd)),
            }]}
        />

    </div>
}